/**
 * Service API pour les résultats CrossFit — classement général.
 *
 * LOG-168 (2026-08-03) : élagué. getResultsByWod / getPublicResults /
 * formatTime / formatScore (~90 lignes) n'avaient AUCUN appelant, et
 * formatScore portait un format « mm:ss (CAP) » qui n'existe sur aucune
 * surface. Seul getGeneralResults est consommé (EventCrossFitResults.tsx).
 */

const API_URL = process.env.REACT_APP_API_URL || 'https://events.logfit.eu/api/v1';

export interface ResultWodBreakdown {
  wod_id: string;
  wod_name: string;
  wod_number: number;
  points: number;
  heat_id: string | null;
  heat_number: number | null;
}

export interface CrossFitResult {
  rank?: number;
  category_rank?: number;
  team_id: string;
  team_name: string;
  bib_number?: string;
  category_id: string;
  category_name: string;
  category_color?: string;
  total_points?: number;
  wods_completed?: number;
  // Détail par WOD pour l'accordéon (points, heat → accès signatures)
  wods?: ResultWodBreakdown[];
}

export interface GeneralResultsResponse {
  success: boolean;
  event_id: string;
  category_id?: string;
  total_teams: number;
  results: CrossFitResult[];
}

class CrossFitResultsService {
  /**
   * Récupérer le classement général par catégorie
   * Total des points Even Distribution sur tous les WODs
   */
  async getGeneralResults(
    eventId: string,
    categoryId?: string
  ): Promise<GeneralResultsResponse> {
    const params = new URLSearchParams();
    if (categoryId) {
      params.append('category_id', categoryId);
    }

    const url = `${API_URL}/events/${eventId}/results/general${
      params.toString() ? `?${params.toString()}` : ''
    }`;

    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Erreur ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}

export const crossfitResultsService = new CrossFitResultsService();
